import React from 'react'

const Footer = () => {
  return (
    <div className="font-vic text-white tracking-widest p-5 w-full border-t border-gray-700">
        <div className="container mx-auto w-full flex flex-row items-center ">
            <div className="flex flex-row items-center justify-between w-full">

            <p className='text-[14px] text-gray-500'> &copy; {new Date().getFullYear()} All Rights Reserved</p>
            <p className='text-[14px] text-gray-500'> +254 742 415 221</p>

            </div>
        </div>
    </div>
  )
}

export default Footer